import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { ClassicEditor } from "ckeditor5";

import "ckeditor5/ckeditor5.css";
import "./EmailTemplateStyle.scss";
import { editorConfigForMail } from "./CkEditorConfig";
import { CKEditor } from "@ckeditor/ckeditor5-react";


const EmailTemplateEditorComponent = ({
  onCKEditorChange,
  value,
  isDisable,
  ...editorProps
}) => {
  // const editorRef = useRef(null);
  const [isReady, setIsReady] = useState(false);
  // const isInitialLoad = useRef( true );

  useEffect(() => {
    setIsReady(true);
    return () => setIsReady(false);
  }, []);

  // useEffect(() => {
  //   if (
  //     editorRef.current &&
  //     value !== undefined &&
  //     isInitialLoad.current
  //   ) {
  //     editorRef.current.setData(value || "");
  //     isInitialLoad.current = false;
  //   }
  // }, [value]);

  useEffect(() => {
    setIsReady(true);
    return () => setIsReady(false);
  }, []);

  return (
    <div className="main-container">
      <div className="ckeditor-style-for-emailtemplate">
        {isReady && (
          <CKEditor
            editor={ClassicEditor}
            config={editorConfigForMail}
            data={value || ""}
            onChange={(event, editor) => {
              const data = editor.getData();
              onCKEditorChange(data, editor);
            }}
            // onReady={(editor) => {
            //   editorRef.current = editor;
            // }}

            disabled={isDisable}
            {...editorProps}
          />
        )}
      </div>
    </div>
  );
};

EmailTemplateEditorComponent.propTypes = {
  onCKEditorChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  isDisable: PropTypes.bool,
};

export default EmailTemplateEditorComponent;
